import { render } from "./AdminIslandShell.vue?vue&type=template&id=a33f91e6"
import script from "./AdminIslandShell.vue?vue&type=script&lang=js"
export * from "./AdminIslandShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__